module.exports = __webpack_public_path__ + "img/4.4d14bd14.png";